{
  "cycle.entite.attention_reports": "Attention item postponements",
  "cycle.entite.conditions_acceptations": "Terms of use acceptances",
  "cycle.entite.confirmations_identite": "Identity confirmations",
  "cycle.entite.delegation_droits": "Rights passed on by delegation",
  "cycle.entite.exports_personnels": "Personal data exports",
  "cycle.entite.favoris": "Favourite spaces",
  "cycle.entite.jetons_personnels": "Personal tokens",
  "cycle.entite.preferences_affichage": "Display preferences",
  "cycle.entite.profils_personnels": "Personal profiles",
  "cycle.entite.recents": "Recently visited spaces",
  "cycle.entite.statuts_personnels": "Absence statuses",
  "journalAudit.action.account.deletion_cancelled": "Account deletion cancelled",
  "journalAudit.action.account.deletion_requested": "Account deletion requested",
  "journalAudit.action.account.display_preferences_updated": "Display preferences updated",
  "journalAudit.action.account.export_created": "Personal data export prepared",
  "journalAudit.action.account.export_downloaded": "Personal data export downloaded",
  "journalAudit.action.account.profile_updated": "Personal profile updated",
  "journalAudit.action.account.status_updated": "Absence status updated",
  "journalAudit.action.account.terms_accepted": "Terms of use accepted",
  "journalAudit.action.invitation.declined": "Project invitation ignored"
}
